export const usePersistState = <T>(key: string, initialValue: T): Ref<T> => {
  const defaultValue = initialValue
  const get = (key: string) => {
    try {
      return JSON.parse(localStorage.getItem(key) + '')
    } catch {
      return null
    }
  }
  const storedValue = get(key)
  const set = (key: string, value: T) => {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch {
      // localStorage が利用できない環境（Safari のストレージ制限など）では永続化しない
    }
  }

  if (storedValue === null) {
    set(key, defaultValue)
  }
  const refs: Ref<T> = useState<T>(key, () => (storedValue ?? defaultValue) as T)
  watch(refs, (newValue) => set(key, newValue))
  return refs
}
